export default function calcMaxConvCoLtv(occupancy){
    if(occupancy=="Primary"){
        return 75
    }else{
        return 65
    }
}